<template>
  <div style="border: 1px solid #999" class="pa-2">
    <div class="v-label theme--light pb-2">{{ ctrlTitle }}</div>
    <v-chip
      label
      close
      class="mt-2 mr-2"
      v-for="(item, index) in value"
      :key="index"
      @click="edit(item)"
      @click:close="remove(index)"
      >{{ item.name }} = {{ item.value }}</v-chip
    >
    <v-chip color="primary" title="Add Filter" @click="add" class="mt-2">
      <v-icon>mdi-plus</v-icon>
    </v-chip>
    <v-dialog v-model="dialog" width="400" scrollable>
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="dataName"
                  hide-details
                  filled
                  label="Parameter Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <FieldValuePickerBase
                  v-model="dataValue"
                  title="Value"
                  :component="component"
                  :containers="containers"
                  :type="dataType"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save" :disabled="!dataName"
            >OK</v-btn
          >
          <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldValuePickerBase from "./FieldValuePickerBase.vue";

export default {
  name: "ScriptParamsEditor",

  components: { FieldValuePickerBase },

  props: ["title", "value", "component", "containers"],

  data() {
    return {
      dialog: false,
      dataName: null,
      dataValue: null,
      dataType: "text",
      items: [],
      dialogTitle: "",
      editingItem: null,
    };
  },

  computed: {
    ctrlTitle() {
      return this.title ? this.title : "Filters";
    },
  },

  watch: {
    value(v) {
      if (v) this.items = v;
    },
  },

  mounted() {
    if (this.value) this.items = this.value;
  },

  methods: {
    add() {
      this.dialogTitle = "Add";
      this.dataName = null;
      this.dataValue = null;
      this.dataType = "text";
      this.dialog = true;
      this.editingItem = null;
    },
    edit(item) {
      this.editingItem = item;
      this.dialogTitle = "Edit";
      this.dataName = item.name;
      this.dataValue = item.value;
      this.dataType = item.valueType;
      this.dialog = true;
    },
    save() {
      if (this.editingItem) {
        this.editingItem.name = this.dataName;
        this.editingItem.value = this.dataValue;
        this.editingItem.valueType = this.dataType;
      } else {
        this.items.push({
          name: this.dataName,
          value: this.dataValue,
          valueType: this.dataType,
        });
      }

      this.dialog = false;
      this.$emit("input", this.items);
    },
    typeChange(t) {
      this.dataValue = null;
      this.dataType = t;
    },
    remove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
  },
};
</script>
